export default "__VITE_ASSET__D$ge0sdW__"